import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IUITKSelectItemProps } from '@uitk/angular';
import { OrderDetailDto } from 'src/app/dtos/order-detail-dto.model';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-aha-royalty',
  templateUrl: './aha-royalty.component.html',
  styleUrls: ['./aha-royalty.component.css']
})
export class AhaRoyaltyComponent implements OnInit {
  private readonly _configService: ConfigService;
  @Input() orderDetailDto: OrderDetailDto = new OrderDetailDto();
  @Output() enableSave = new EventEmitter<boolean>();
  coveredLivesList = [
    { id: 'Payer - Covered Lives', label: 'Payer - Covered Lives', value: 'Payer - Covered Lives' },
    { id: 'Non-Payer', label: 'Non-Payer', value: 'Non-Payer' }];

  selectedCoveredLivesType: IUITKSelectItemProps = { id: 'Select', label: 'Select', value: 'Select' };
  livesCountRequired = false;
  showError = false;
  livesCount: number = 0;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  ngOnInit(): void {
    //set the default value for covered lives type
    if(this.orderDetailDto.id > 0 || this.orderDetailDto.configSetSaved){
      this.selectedCoveredLivesType = this.orderDetailDto.ahaRoyaltyDto == null? this.coveredLivesList[1]:this.coveredLivesList[0];
      this.livesCount = this.orderDetailDto.ahaRoyaltyDto?.coveredLives??0;
      this.livesCountRequired = this.selectedCoveredLivesType.value === 'Payer - Covered Lives';
    }
  }
  onChangeCoveredLivesType(event: any) {
    console.log(event);
    this.selectedCoveredLivesType = event.value;
    if (this.selectedCoveredLivesType.value === 'Payer - Covered Lives') {
      this.livesCountRequired = true;
    }
    else {
      this.livesCountRequired = false;
    }
  }
  save(): boolean {
    if ((this.selectedCoveredLivesType.value === 'Payer - Covered Lives' && this.livesCount <= 0) || this.selectedCoveredLivesType.label === 'Select') {
      this.showError = true;
      return false;
    }
    else if(this.selectedCoveredLivesType.value === 'Non-Payer'){
      this.livesCount = 0;
      this.orderDetailDto.ahaRoyaltyDto = null;
    }
    else{
      this.orderDetailDto.ahaRoyaltyDto = {
        id: 0,
        orderDetailId: this.orderDetailDto.id,
        coveredLives: this.livesCount
      };
    }
    this.showError = false;
    this.enableSave.emit(true);
    return true;
  }

}
